import type { RateTable } from './types/RateTable';
import type { RateTableErrorInterface } from './types/RateTableErrorInterface';

export class RateTableInternalError
  extends Error
  implements RateTableErrorInterface
{
  readonly title = 'Unable to load offers';
  readonly copy =
    'Internal error, unable to locate rate table. Please contact TSG to resolve.';
  readonly rateTable?: RateTable;

  constructor(message: string, rateTable?: RateTable) {
    const identifier = '[RATE_TABLE_INTERNAL_ERROR]';

    super(`${identifier} ${message}`);

    this.name = identifier;
    this.rateTable = rateTable;
  }
}
